import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { AppRewardConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/AppReward';
import { ERR_MOD_APP_REWARD_CONFIG, SUC_MOD_APP_REWARD_CONFIG } from '../../../../utils/strings';

export const useModifyAppRewardConfig = () => {
  const { submit } = useExerciseSubmission(
    AppRewardConfiguration.AppRewardConfiguration_Modify,
    SUC_MOD_APP_REWARD_CONFIG,
    ERR_MOD_APP_REWARD_CONFIG,
  );
  return submit;
};
